import { useEffect, useState } from "react";
import { artists, authors } from "../data/Data";
import { productDetails, blog } from "../data/Data";

const useFirebase = () => {
  const [sideBar, setSideBar] = useState(false);
  const [user, setUser] = useState({});
  const [data, setData] = useState([]);
  const [detailsInfo, setDetailsInfo] = useState([]);
  const [selecetBlockChain, setSelectedBlockChain] = useState("");
  const [selecetCategory, setSelectedCategory] = useState("");
  const [selecetPrice, setSelectedPrice] = useState("");
  const [artistsData, setArtistsData] = useState([]);
  const [profileInfo, setProfileInfo] = useState({})
  const [isLogin, setIsLogin] = useState(false)
  const [loader,setLoader] = useState(true)
  const [stickyNav,setStickyNav] = useState(false)

  const showDummyImage = ({ currentTarget }, imageSize) => {
    console.log(imageSize)
    currentTarget.onerror = null;
    currentTarget.src = `https://dummyimage.com/${imageSize}`;
  }

  useEffect(() => {
    const result = authors.filter(item => item.currency.includes(selecetBlockChain) && item.category.includes(selecetCategory));
    if (selecetPrice === 'lth') {
      const newResult = result.sort((a, b) => parseInt(a.price) - parseInt(b.price))
      setData(newResult)
    } else if (selecetPrice === 'htl') {
      const newResult = result.sort((a, b) => parseInt(b.price) - parseInt(a.price))
      setData(newResult)
    } else {
      setData(result)
    }
  }, [selecetBlockChain, selecetCategory, selecetPrice]);

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = process.env.REACT_APP_FAV_ICON
  }, []);

  useEffect(() => {
    const onPageLoad = () => {
      setLoader(false);
    };
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);
  
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('credentials'));
    if (items) {
      setUser(items);
    }
  }, [isLogin]);


  useEffect(() => {
    setDetailsInfo(productDetails);
    setArtistsData(artists);
  }, []);


  return {
    sideBar,
    setSideBar,
    user, setUser,
    data, detailsInfo,loader,
    selecetCategory, setSelectedCategory,
    selecetBlockChain, setSelectedBlockChain,
    selecetPrice, setSelectedPrice, artistsData,stickyNav,setStickyNav,
    isLogin, setIsLogin, profileInfo, setProfileInfo, blog, showDummyImage
  };
};
export default useFirebase;
